import React from "react";

import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";

import img4 from "../../images/WCLQQpic.png";

const WCLQQ = () => {
  return (
    <div className="QL__PG__Sec__WCLQQ">
      <Container>
        <Grid container spacing={8}>
          <Grid
            item
            xs={12}
            md={6}
            justifyContent="center"
            justifySelf="center"
          >
            <Box sx={{ display: { xs: "none", md: "flex" } }}>
              <img src={img4} alt="reading image" />
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            justifyContent="center"
            justifySelf="center"
          >
            <h1 className="HeadingAll">Why Choose Learn Quran Quick?</h1>
            <p className="pt-4">
              At LearnQuranQuick, we are determined to provide people with a
              platform that helps them stay enlightened with the teachings and
              fundamentals of Islam!
              <br />
              <br />
              We’ve devised many Quran learning courses comprised of the time of
              your availability, areas you want to improve, or the teachers of
              your liking. LearnQuranQuick offers courses that are suitable for
              people of different ages. Just like in-person learning, our
              teachers and their teachings can also be surveilled to mitigate
              any concerns for the parents. We have designed a lot of helpful
              courses that can prove to be feasible to a lot of people around
              the globe.
            </p>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box sx={{ display: { xs: "flex", md: "none" } }}>
              <img src={img4} alt="reading image" />{" "}
            </Box>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};
export default WCLQQ;
